import { Steps } from 'primereact/steps';

const StepsComponent = ({ activeIndex, tipoDocumento }) => {
    const items = [
        {
            label: 'Buscar Cliente'
        },
        {
            label: tipoDocumento === "nota-venta" ? 'Nota de Venta' : 'Cotización'
        }
    ];

    return (
            <Steps model={items} activeIndex={activeIndex} className="p-0" />
    );
};

export default StepsComponent;
